export { default as Image } from './ImageComponent';
